export default class JsonHandler {
    parse(data) {
        let result;

        try {
            result = JSON.parse(data);
        } catch (e) {
            console.error(e.message, 'Could not decode JSON, returning original data');
            result = data;
        }

        return result;
    }
}
